import React, { useEffect, useState, useCallback } from "react";
import Backicon from "../../assets/icon/leftIcon.png";
import { getCategory } from "../../state/categoryState";
import { getRestaurant } from "../../state/restaurantState";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import useGetImages from "../../components/useGetImages";

const CategoryCard = React.memo(({ id, category }) => {
  const { image: uri } = useGetImages(
    "category_pictures",
    id,
    category?.CATEGORY
  );

  if (!category) return null;

  return (
    <Link
      to={`/menu?category=${category.CATEGORY}`}
      className="hover:scale-95 transition-transform ease-in-out duration-300 z-10"
    >
      <div className="p-4 bg-zinc-100 m-2 rounded-lg h-50 flex flex-col justify-center items-center shadow-sm hover:shadow-md transition-shadow">
        {uri && (
          <img
            src={uri}
            alt={category.CATEGORY}
            className="w-24 h-24 object-cover rounded-full shadow-md mb-3"
          />
        )}

        <p className={`text-center text-stone-700 font-medium text-sm ${!uri ? 'py-2' : ''}`}>
          {category.CATEGORY}
        </p>
      </div>
    </Link>
  );
});

const Category = ({ id }) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.categories.category);
  const restaurants = useSelector((state) => state.restaurants.restaurant);

  useEffect(() => {
    const data = { path: id + "/categoryno.json" };
    const data3 = { path: id + "/restaurant.json" };

    dispatch(getCategory(data));
    dispatch(getRestaurant(data3));
  }, [dispatch, id]);

  return (
    <div className="min-h-screen flex flex-col pb-16 bg-gray-50">
      <div className="p-4 bg-white shadow-sm sticky top-0 z-50">
        <Link to="/" className="flex items-center mb-4">
          <img src={Backicon} alt="back" className="rounded-full w-8 h-8" />
        </Link>
        <h3 className="font-bold text-2xl text-stone-800">Kategoriler</h3>
      </div>
      
      {categories && categories.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 p-2">
          {categories.map((item, index) => (
            <CategoryCard id={id} category={item} key={item.CATEGORY || index} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center mt-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#fecc4c]"></div>
          <p className="mt-4 text-gray-600">Kategoriler yükleniyor...</p>
        </div>
      )}
    </div>
  );
};

export default Category;
